import { checkOwnershipByID } from "~/services/chekcProduct"

export const isOwner = async () => {
  const owner = await checkOwnershipByID({ productID: "655ee7bb1727b2465e1307a0" })
  return owner.data !== null
}
